import { render, staticRenderFns } from "./ViewDispatch.vue?vue&type=template&id=22ce0b47&scoped=true&"
import script from "./ViewDispatch.vue?vue&type=script&lang=js&"
export * from "./ViewDispatch.vue?vue&type=script&lang=js&"
import style0 from "./ViewDispatch.vue?vue&type=style&index=0&id=22ce0b47&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ce0b47",
  null
  
)

export default component.exports